import { TModel as TUser, create as createUser } from 'models/User'
import { TBreadcrumb } from 'services/LayoutService'
import { IRunItem } from '../utils/modelHelpers'
import { inputs } from '../models/complex-model/inputs'

export const initialState = {
  currentUser: createUser({ id: 'public' }),
  layout: {
    isExpanded: true,
    isHeaderLarge: false,
    breadcrumbs: [] as TBreadcrumb[],
    dialog: {
      open: false,
      title: '',
      content: '',
      cancel: true,
      actionLabel: '',
      action: () => {
      },
    },
    snackbar: {
      open: false,
      variant: 'success',
      message: 'Success',
    },
  },
  users: {
    isLoading: false,
    list: {
      items: [] as TUser[],
      total: 0,
      filter: {
        'page': 0,
        'size': 5 as SizeOption,
        'user.suspended': false,
        'user.email': null as null | string,
        'user.role': null as null | number,
        'sort': 'name,asc',
      },
    },
    detail: {
      user: createUser({}),
    },
  },
  simulation: {
    defaultScenariosInitialised: false,
    values: inputs.reduce((o, i) => ({ ...o, [i.var]: i.value }), {}) as TObjectAny,
    run: [] as IRunItem[],
    storedRuns: [] as IStoredRun[]
  },
}

export interface IStoredRun {
  key: string | number
  name: string
  isActive: boolean
  isDefaultScenario?: boolean
  values: TObjectAny
  color: string
  run: IRunItem[]
}

export type IAppState = typeof initialState

export interface IState {
  app: IAppState
  internal: TObjectAny
}
